export const WHATS_NEW_HEADER = "What's New";

export const ARTICLE_VIEW = "VIEW";

export const DEFAULT_PAGE = 0;
export const PAGE_SIZE = 6;
